var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tissue-web"},[_c('tooltip',_vm._b({},'tooltip',_vm.tooltip,false)),_c('svg',{staticClass:"tissue-web__svg",attrs:{"viewBox":("0 0 " + _vm.width + " " + _vm.height)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }